import { colors } from '../../colors';
var book = {
  fieldBorderColor: colors.metal,
  errorColor: colors.warningRed
};
export default book;